import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePortalTracking } from '../hooks/usePortalTracking';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../styles/Portal.css';

const Portal = () => {
  const { user, login } = useAuth();
  const { trackPortalTracking } = usePortalTracking();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  // Track portal access
  const handleAdminAccess = () => {
    trackPortalTracking({
      action: 'admin_analytics_access',
      timestamp: new Date(),
      userId: user?.id
    });
  };

  // Only render admin analytics link if user is admin
  const renderAdminContent = () => {
    if (user?.email === 'admin@causeandimpact.org') {
      return (
        <div className="admin-section">
          <Link 
            to="/portal/admin/analytics" 
            onClick={handleAdminAccess}
            className="portal-link"
          >
            Analytics Dashboard
          </Link>
        </div>
      );
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const email = e.target.email.value;
      const password = e.target.password.value;
      
      await login({ email, password });
      navigate('/portal/admin/analytics');
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred during login. Please try again.');
    }
  };

  return (
    <div className="portal-wrapper">
      <div className="portal-container">
        <h1>Cause Portal</h1>
        <p className="portal-subtitle">Access your Cause Dashboard</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-wrapper">
              <input 
                type={showPassword ? "text" : "password"}
                id="password" 
                name="password" 
                placeholder="Enter your password"
              />
              <button 
                type="button" 
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <button type="submit" className="login-button">Log In</button>
          
          <div className="form-footer">
            <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>
            <Link to="/forgot-username" className="forgot-link">Forgot Username?</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Portal; 